// extracted by mini-css-extract-plugin
export default {"pageContainer":"PageContainer_pageContainer__F4ebY"};